// extracted by extract-css-chunks-webpack-plugin
module.exports = {"awardsDropdownContent":"RKMmI-","awardsDropdownTitle":"_2E7HfY","light":"oFPoRV"};